module.exports = __webpack_public_path__ + "img/0ebb0a6.jpg";